import React from 'react';
import { Container } from './Container';
import { Label } from './Label';
export function Services() {
  const services = [{
    title: 'Strategy',
    desc: 'The why before the what. Audience-first thinking that earns its place in the deck.'
  }, {
    title: 'Branding',
    desc: 'Identities that hold up at every size, every surface, every scroll.'
  }, {
    title: 'Social',
    desc: "Content that doesn't just post — it pays off."
  }, {
    title: 'Content',
    desc: 'Stories shot, written, and cut for how people actually watch.'
  }, {
    title: 'Web',
    desc: 'Sites that load fast, look right, and convert.'
  }];
  return <section className="py-[clamp(70px,10vw,140px)] border-b border-brand-gray300" id="services" data-id="element-136" data-mp="q59bq2d4se4j">
      <Container data-id="element-137" data-mp="l4bvhvbolu5o">
        <div className="flex justify-between items-end gap-[40px] mb-[clamp(40px,6vw,80px)] flex-wrap" data-id="element-138" data-mp="l4u29lvyzqru">
          <Label className="self-start" data-id="element-139" data-mp="g728embrlul0">01 · Services</Label>
          <h2 className="text-[clamp(2.2rem,5.6vw,5.2rem)] font-black leading-[0.95] tracking-[-0.025em] max-w-[18ch]" data-id="element-140" data-mp="36c7py8sboqo6">
            Five disciplines. One team. No handoffs.
          </h2>
        </div>

        <div className="grid grid-cols-5 max-[900px]:grid-cols-2 max-[540px]:grid-cols-1 border-t border-brand-gray300" data-id="element-141" data-mp="2xcks1wysy2zv">
          {services.map((service, i) => <div key={i} className="group p-[36px_24px] cursor-pointer transition-colors duration-250 ease-out hover:bg-brand-black hover:text-brand-white
                         border-r border-brand-gray300 last:border-r-0
                         max-[900px]:border-b max-[900px]:[&[data-even='true']]:border-r-0
                         max-[540px]:border-r-0" data-even={(i + 1) % 2 === 0} data-id="element-142" data-mp="3q0gu7h754n41" data-mpi={i}>
              <h3 className="text-[clamp(1.4rem,2.2vw,2rem)] font-black tracking-[-0.02em] mb-[16px]" data-id="element-143" data-mp="24mcc8brqnuog">
                {service.title}
              </h3>
              <p className="text-[14px] leading-[1.5]" data-id="element-144" data-mp="1pjuh78jyeyeg">{service.desc}</p>
            </div>)}
        </div>
      </Container>
    </section>;
}